import { ThemeProvider } from '@insolitum/ui';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { NexusChatWidget } from '../components/NexusChatWidget';

import { AuthProvider } from './AuthProvider';
import { TenantProvider } from './TenantProvider';
import { WebSocketProvider } from './WebSocketProvider';

interface AppProvidersProps {
  children: ReactNode;
}

// Routes that embed their own inline NexusChatWidget — rendering the global
// floating orb there gives the user two independent conversations with the
// same assistant on one screen (and the orb overlaps the cockpit scene).
// /partner/akademia ma własny panel „Zapytaj Nexusa", a pływająca kula
// (bottom-6 right-6, z-[100]) przesłaniała jego pole i przycisk wysyłki.
const INLINE_NEXUS_ROUTES = [
  '/super-admin/cockpit',
  '/super-admin/super-nexus',
  '/admin/jarvis',
  '/partner/akademia',
];

function GlobalNexusWidget() {
  const { pathname } = useLocation();
  if (INLINE_NEXUS_ROUTES.some((route) => pathname.startsWith(route))) return null;
  return <NexusChatWidget />;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    // ThemeProvider ustawia data-mode/density/contrast na <html> — to te atrybuty
    // czyta Aurora. Wartości startowe malowane są wcześniej, przez skrypt inline
    // w index.html (musi być zgodny z `themeInitScript` — pilnuje tego test
    // aurora-design-invariants).
    <ThemeProvider>
      <AuthProvider>
        <TenantProvider>
          <WebSocketProvider>
            {children}
            {/* NEXUS AI Assistant - globally available on all pages for authenticated users */}
            <GlobalNexusWidget />
          </WebSocketProvider>
        </TenantProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
